import type { Nullable } from "vite-node"
import type { TileGraphNode } from "../../engine/TileGraphNode/TileGraphNode.type"
import type { Entity } from "../index"
import type { EntityLayerId } from "./EntityLayerId.enum"
import isEntityLayerIdTerrain1 from "./isEntityLayerIdTerrain1"

export type Terrain1Entity = Entity & {
  layer_id: EntityLayerId.TerrainL1,
}

export default function getTileGraphNodeLayerTerrain1Entity(node: TileGraphNode): Nullable<Terrain1Entity> {
  return node.ents().find(isEntityLayerIdTerrain1)
}